module.exports = __webpack_public_path__ + "img/waterpolo.ec214251.png";